import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
};

export const STATUS_LABELS = {
  em_analise: "Em Análise",
  aguardando_assinatura: "Aguardando Assinatura",
  ativo: "Ativo",
  inadimplente: "Inadimplente",
  finalizado: "Finalizado",
  rescindido: "Rescindido",
  aprovado: "Aprovado",
  aprovado_com_restricao: "Aprovado c/ Restrição",
  reprovado: "Reprovado",
  pago: "Pago",
  pendente: "Pendente",
  vencido: "Vencido",
};

export const STATUS_CLASS = {
  em_analise: "status-analise",
  aguardando_assinatura: "status-assinatura",
  ativo: "status-ativo",
  inadimplente: "status-inadimplente",
  finalizado: "status-finalizado",
  rescindido: "status-finalizado",
  aprovado: "status-aprovado",
  aprovado_com_restricao: "status-pendente",
  reprovado: "status-reprovado",
  pago: "status-ativo",
  pendente: "status-pendente",
  vencido: "status-inadimplente",
};

export const PLAN_LABELS = { basico: "Básico", plus: "Fit", ultra: "Ultra" };

export const fileUrl = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

STATUS_LABELS.cancelado = "Cancelado";
STATUS_LABELS.erro = "Erro na emissão";
STATUS_CLASS.cancelado = "status-finalizado";
STATUS_CLASS.erro = "status-reprovado";
